import axios from 'axios';

const baseApi = 'https://journalapi.rhc.ac.ir/Admin'; 

const fetchFile = (endpoint, fileId, articleId) => {
  const token = localStorage.getItem("token");

  
  return axios.post(
    `${baseApi}/${endpoint}`,
    { 
        fileId,
         articleId 
        },
    {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
};

// توابع مختلف برای دانلود فایل‌ها
const downloadManuscript = (fileId, articleId) => fetchFile('ShowArticleManuscriptFile', fileId, articleId);
const downloadTable = (fileId, articleId) => fetchFile('ShowArticleTableFile', fileId, articleId);
const downloadFigure = (fileId, articleId) => fetchFile('ShowArticleFigureFile', fileId, articleId);
const downloadCoverLetter = (fileId, articleId) => fetchFile('ShowArticleCoverLetterFile', fileId, articleId);
const downloadSupplementary = (fileId, articleId) => fetchFile('ShowSupplementaryFile', fileId, articleId);
const downloadRelated = (fileId, articleId) => fetchFile('ShowRelatedFile', fileId, articleId);

export default {
  downloadManuscript,
  downloadTable,
  downloadFigure,
  downloadCoverLetter,
  downloadSupplementary,
  downloadRelated,
};
